module.exports = __webpack_public_path__ + "static/media/leaflink-logo.85b06304.png";